(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const kaart = document.getElementById('looxReviews');
    if (!kaart) return;
    const toets = () => {
      const frame = document.getElementById('looxReviewsFrame');
      if (frame && frame.getBoundingClientRect().height > 120) {
        kaart.classList.add('tw-loox-gevuld');
        return true;
      }
      return false;
    };
    if (toets()) return;
    // De widget injecteert zijn iframe asynchroon en groeit daarna via een
    // eigen resize-handler; de container groeit mee, dus een observer op de
    // container vangt beide momenten.
    const waarnemer = new ResizeObserver(() => {
      if (toets()) waarnemer.disconnect();
    });
    waarnemer.observe(kaart);
  })();

  (() => {
    // Zelfde patroon voor de video-slider: de compacte marges uit het
    // stylesheet-blok gelden pas zodra de slider echt hoogte heeft.
    document.querySelectorAll('.shopify-section--apps .shopify-app-block > loox-video-slider-widget').forEach((reel) => {
      // Op een productpagina toont de reel alleen de videoreviews van dit
      // product; de app leest het attribuut bij zijn latere, externe
      // initialisatie. Zonder eigen video's blijft de widget leeg en houdt
      // de sectie geen ruimte in.
      const bron = reel.closest('[data-tw-reel-product]');
      if (bron && !reel.getAttribute('product-id')) {
        reel.setAttribute('product-id', bron.getAttribute('data-tw-reel-product'));
      }
      const blok = reel.parentElement;
      const toets = () => {
        if (reel.getBoundingClientRect().height > 100) {
          blok.classList.add('tw-reel-gevuld');
          return true;
        }
        return false;
      };
      if (toets()) return;
      const waarnemer = new ResizeObserver(() => {
        if (toets()) waarnemer.disconnect();
      });
      waarnemer.observe(blok);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banden = document.querySelectorAll('[data-tw-ba-band]');
    if (!banden.length) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    banden.forEach((band) => {
      band.setAttribute('data-tw-armed', '');

      const vergelijker = band.querySelector('before-after');
      let sweepGestopt = false;
      if (vergelijker) {
        const stop = () => { sweepGestopt = true; };
        ['pointerdown', 'touchstart', 'keydown'].forEach((type) => {
          vergelijker.addEventListener(type, stop, { capture: true, passive: true, once: true });
        });
      }

      const kijker = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        kijker.disconnect();
        band.classList.add('tw-ba--inview');

        if (!vergelijker) return;
        // Na de fade en de eigen intro van de schuif: één rustige
        // heen-en-terug-beweging met de greep, zodat zichtbaar is dat hij
        // versleepbaar is. Stopt meteen zodra de bezoeker zelf sleept.
        setTimeout(() => {
          if (sweepGestopt) return;
          const basis = parseFloat(getComputedStyle(vergelijker).getPropertyValue('--before-after-initial-cursor-position')) || 50;
          const uitslag = 12;
          const duur = 2200;
          let start = null;
          const stapje = (nu) => {
            if (sweepGestopt) return;
            if (start === null) start = nu;
            const p = Math.min((nu - start) / duur, 1);
            const golf = (1 - Math.cos(2 * Math.PI * p)) / 2;
            vergelijker.style.setProperty('--before-after-cursor-position', (basis + uitslag * golf) + '%');
            if (p < 1) requestAnimationFrame(stapje);
          };
          requestAnimationFrame(stapje);
        }, 1400);
      }, { threshold: 0.22 });

      kijker.observe(band);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  // "Laad meer" op de mobiele intent-rij: klapt de kaarten vanaf de zevende uit.
  // De knop staat alleen in de HTML bij meer dan zes blocks en is op desktop
  // met CSS verborgen, dus deze listener draait daar nooit.
  document.addEventListener('click', (event) => {
    const knop = event.target.closest('.tw-collist__more');
    if (!knop) return;
    const stack = knop.closest('.section-stack');
    const open = stack.classList.toggle('tw-collist--intent-open');
    knop.setAttribute('aria-expanded', String(open));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Filterpaneel met specificaties (collectieveld "Filters"): het formulier in
     de drawer van het theme draagt per groep checkboxes (name tw-f-<sleutel>).
     Binnen een groep telt elk vinkje (OF), groepen combineren met EN. Het
     filteren gebeurt in de browser: cellen zonder passende waarde krijgen
     tw-colfilters-hide, promotegels blijven staan. Boven het raster staan de
     actieve keuzes als verwijderbare chips met een wis-alles-knop. Toepassen
     en Alles wissen sluiten het paneel (de drawer luistert zelf naar submit en
     reset); een gewijzigde sortering in het paneel gaat als sort_by in de URL
     naar de server (de pagina herlaadt, aangevinkte filters beginnen dan
     opnieuw). Luistert ook naar shopify:section:load, want de editor
     voegt de sectie na elke instelling opnieuw in. */
  (function () {
    var PREFIX = 'tw-f-';
    var KRUIS = '<svg aria-hidden="true" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    function initFilters(scope) {
      var forms = (scope || document).querySelectorAll('form[data-tw-colfilters]');
      Array.prototype.forEach.call(forms, function (form) {
        if (form.twColfilters) return;
        form.twColfilters = true;
        var sectie = form.closest('.shopify-section') || document;
        var raster = sectie.querySelector('.tw-collection__grid');
        var actief = sectie.querySelector('[data-tw-colfilters-active]');
        var leeg = sectie.querySelector('.tw-colfilters__empty');
        var wisLabel = form.getAttribute('data-tw-clear-label') || '';
        if (!raster) return;

        function inputs() {
          return form.querySelectorAll('input[type="checkbox"][name^="' + PREFIX + '"]');
        }

        function keuzes() {
          var per = {};
          Array.prototype.forEach.call(inputs(), function (input) {
            if (!input.checked) return;
            var key = input.name.slice(PREFIX.length);
            if (!per[key]) per[key] = [];
            per[key].push(input.value);
          });
          return per;
        }

        function pasToe() {
          var per = keuzes();
          var keys = Object.keys(per);
          var zichtbaar = 0;
          var cellen = raster.querySelectorAll('li.tw-collection__cell:not(.tw-promocel)');
          Array.prototype.forEach.call(cellen, function (cel) {
            var ok = keys.every(function (k) { return per[k].indexOf(cel.getAttribute('data-tw-f-' + k)) !== -1; });
            cel.classList.toggle('tw-colfilters-hide', !ok);
            if (ok) zichtbaar += 1;
          });
          if (leeg) leeg.hidden = !(keys.length > 0 && zichtbaar === 0);
          if (!actief) return;
          actief.innerHTML = '';
          keys.forEach(function (k) {
            per[k].forEach(function (waarde) {
              var chip = document.createElement('button');
              chip.type = 'button';
              chip.className = 'tw-colfilters__chip';
              chip.setAttribute('data-tw-key', k);
              chip.setAttribute('data-tw-value', waarde);
              chip.appendChild(document.createTextNode(waarde));
              chip.insertAdjacentHTML('beforeend', KRUIS);
              actief.appendChild(chip);
            });
          });
          if (keys.length > 0 && wisLabel) {
            var wis = document.createElement('button');
            wis.type = 'button';
            wis.className = 'tw-colfilters__clear';
            wis.textContent = wisLabel;
            actief.appendChild(wis);
          }
          actief.hidden = keys.length === 0;
        }

        form.addEventListener('change', pasToe);
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var sortInput = form.querySelector('input[name="sort_by"]:checked');
          var huidig = form.getAttribute('data-tw-sort-current') || '';
          if (sortInput && sortInput.value !== huidig) {
            var doel = new URL(window.location.href);
            doel.searchParams.set('sort_by', sortInput.value);
            doel.hash = '';
            window.location.href = doel.toString();
            return;
          }
          pasToe();
        });
        form.addEventListener('reset', function () { window.setTimeout(pasToe, 0); });

        if (actief) {
          actief.addEventListener('click', function (e) {
            var chip = e.target.closest('.tw-colfilters__chip');
            if (chip) {
              var key = chip.getAttribute('data-tw-key');
              var waarde = chip.getAttribute('data-tw-value');
              Array.prototype.forEach.call(inputs(), function (input) {
                if (input.name === PREFIX + key && input.value === waarde) input.checked = false;
              });
              pasToe();
              return;
            }
            if (e.target.closest('.tw-colfilters__clear')) {
              Array.prototype.forEach.call(inputs(), function (input) { input.checked = false; });
              pasToe();
            }
          });
        }
        pasToe();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initFilters(document); });
    } else {
      initFilters(document);
    }
    document.addEventListener('shopify:section:load', function (e) { initFilters(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  // Techweise — de stappenrij benadrukt één stap tegelijk.
  //
  // Desktop: alle drie de kaarten staan naast elkaar in beeld, dus scrollen zegt
  // niets. Daar klik je op een kaart of op een blokje in de balk.
  // Mobiel: de kaarten staan onder elkaar, dus daar bepaalt de scrollpositie
  // welke stap aan is. Klikken werkt er ook, dat overschrijft de scroll dan.
  //
  // Zonder JS of met prefers-reduced-motion staat alles vol, dus de inhoud is
  // altijd leesbaar.
  (() => {
    const init = (rij) => {
      if (rij.dataset.twStepsInit) return;
      rij.dataset.twStepsInit = '1';

      const kaarten = [...rij.querySelectorAll('.multi-column__item')];
      if (!kaarten.length) return;

      const sectie = rij.closest('.tw-steps');
      const balk = sectie ? [...sectie.querySelectorAll('.tw-steps__progress-step')] : [];

      let actief = 0;
      let handmatig = false;

      const teken = () => {
        kaarten.forEach((kaart, i) => kaart.classList.toggle('is-active', i <= actief));
        balk.forEach((stap, i) => {
          stap.classList.toggle('is-active', i <= actief);
          if (i === actief) stap.setAttribute('aria-current', 'true');
          else stap.removeAttribute('aria-current');
        });
      };

      const zet = (i, doorKlik) => {
        if (doorKlik) handmatig = true;
        actief = Math.max(0, Math.min(i, kaarten.length - 1));
        teken();
      };

      kaarten.forEach((kaart, i) => {
        kaart.addEventListener('click', () => zet(i, true));
      });
      balk.forEach((stap, i) => {
        stap.addEventListener('click', () => {
          zet(i, true);
          // Op mobiel staat de kaart verderop; breng hem in beeld.
          if (window.matchMedia('(max-width: 999px)').matches) {
            kaarten[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });

      if (!('IntersectionObserver' in window)) {
        rij.classList.add('tw-steps--no-js');
        return;
      }

      // De rootMargin knijpt het venster tot een band rond het midden van het
      // scherm, zodat een stap pas "aan" gaat als hij daadwerkelijk in beeld is.
      const zichtbaar = new Set();
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) zichtbaar.add(entry.target);
          else zichtbaar.delete(entry.target);
        }
        // Alleen op mobiel stuurt scrollen de nadruk, en niet meer zodra de
        // bezoeker zelf een stap heeft aangeklikt.
        if (handmatig) return;
        if (!window.matchMedia('(max-width: 999px)').matches) return;

        let tot = -1;
        kaarten.forEach((kaart, i) => { if (zichtbaar.has(kaart)) tot = Math.max(tot, i); });
        if (tot >= 0) zet(tot, false);
      }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });

      kaarten.forEach((kaart) => observer.observe(kaart));
      teken();
    };

    const start = () => document.querySelectorAll('[data-tw-steps]').forEach(init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    // De theme-editor herlaadt secties zonder paginarefresh.
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.twVideoInBeeldGebonden) return;
    if (typeof IntersectionObserver === 'undefined') return;
    window.twVideoInBeeldGebonden = true;

    var HOOK = '[data-tw-autoplay-video]';
    var MARGE = '150px 0px';   // verticaal vooruitlopen, horizontaal niet: in een
                               // carousel mag alleen de zichtbare cel spelen
    var HERVAT_PAUZE = 600;    // ms tussen twee herstelpogingen op dezelfde video

    var eigenPauze = new WeakSet();
    var zichtbaar = new WeakSet();
    var laatsteHervat = new WeakMap();

    function speel(video) {
      var belofte = video.play();
      if (belofte && typeof belofte.catch === 'function') belofte.catch(function () {});
    }

    function pauzeer(video) {
      if (video.paused) return;
      eigenPauze.add(video);
      video.pause();
    }

    var waarnemer = new IntersectionObserver(function (regels) {
      for (var i = 0; i < regels.length; i++) {
        var video = regels[i].target;
        if (regels[i].isIntersecting) {
          zichtbaar.add(video);
          speel(video);
        } else {
          zichtbaar.delete(video);
          pauzeer(video);
        }
      }
    }, { rootMargin: MARGE, threshold: 0 });

    function koppel(video) {
      if (video.dataset.twVideoInit === '1') return;
      video.dataset.twVideoInit = '1';
      /* Vanaf hier stuurt dit script het afspelen. Het attribuut moet weg:
         de browser start een autoplay-video pas als de bron genoeg geladen is,
         dus ná onze eerste beslissing, en de waarnemer vuurt daarna niet meer
         omdat er niets aan de zichtbaarheid verandert. Zo bleven drie video's
         duizenden pixels onder de vouw spelen (gemeten 01-09-2026). Draait dit
         script niet, dan blijft het attribuut staan en verandert er niets. */
      video.removeAttribute('autoplay');
      /* Vangnet voor een start die toch nog uit de browser zelf komt. */
      video.addEventListener('play', function () {
        if (!zichtbaar.has(video)) pauzeer(video);
      });
      // Deze video's hebben geen bediening, dus een pauze komt nooit van de
      // bezoeker: is hij in beeld, dan is dit het toestel dat afknijpt.
      video.addEventListener('pause', function () {
        if (eigenPauze.has(video)) { eigenPauze.delete(video); return; }
        if (!zichtbaar.has(video)) return;
        var nu = Date.now();
        if (nu - (laatsteHervat.get(video) || 0) < HERVAT_PAUZE) return;
        laatsteHervat.set(video, nu);
        speel(video);
      });
    }

    function init(wortel) {
      var lijst = (wortel && wortel.querySelectorAll ? wortel : document).querySelectorAll(HOOK);
      for (var i = 0; i < lijst.length; i++) {
        koppel(lijst[i]);
        waarnemer.observe(lijst[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    // De editor voegt een sectie na elke instellingswijziging opnieuw in.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    // Terug uit een andere tab of app: hervat wat de bezoeker voor zich ziet.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      var lijst = document.querySelectorAll(HOOK);
      for (var i = 0; i < lijst.length; i++) {
        if (zichtbaar.has(lijst[i])) speel(lijst[i]);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-care-plans"] && !Shopify.designMode) return;
  try {
    
  // De koopknop op de Care-pagina: legt de variant met het verkoopplan in de
  // winkelwagen en gaat naar de winkelwagenpagina. Urls en id's komen als
  // data-attributen van de sectie mee.
  (() => {
    const start = () => {
      document.querySelectorAll('[data-tw-care-plans]').forEach((wrap) => {
        if (wrap.dataset.twCareInit) return;
        wrap.dataset.twCareInit = '1';
        const knop = wrap.querySelector('[data-tw-care-add]');
        const fout = wrap.querySelector('[data-tw-care-error]');
        const kies = wrap.querySelector('[data-tw-care-choose]');
        const modellen = Array.from(wrap.querySelectorAll('[data-tw-care-model]'));
        if (!knop) return;

        modellen.forEach((m) => {
          m.addEventListener('click', () => {
            modellen.forEach((x) => x.setAttribute('aria-checked', x === m ? 'true' : 'false'));
            wrap.dataset.twCareVariant = m.dataset.variant;
            if (kies) kies.hidden = true;
          });
        });

        knop.addEventListener('click', async () => {
          if (knop.dataset.bezig) return;
          const variant = parseInt(wrap.dataset.twCareVariant || '', 10);
          if (!variant) {
            if (kies) kies.hidden = false;
            return;
          }
          knop.dataset.bezig = '1';
          knop.classList.add('is-bezig');
          if (fout) fout.hidden = true;
          const item = {
            id: variant,
            quantity: 1,
            properties: { _tw_care_eigen: 'ja' },
          };
          if (wrap.dataset.twCarePlan) item.selling_plan = parseInt(wrap.dataset.twCarePlan, 10);
          try {
            const res = await fetch(`${wrap.dataset.twCareAddUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] }),
            });
            if (!res.ok) throw new Error(`cart/add ${res.status}`);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.location.href = wrap.dataset.twCareCartUrl || '/cart';
          } catch (e) {
            console.error('[tw-care-plans]', e);
            if (fout) fout.hidden = false;
            delete knop.dataset.bezig;
            knop.classList.remove('is-bezig');
          }
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollectionRow(root) {
      var track = root.querySelector('[data-tw-collection-row-track]');
      var prevBtn = root.querySelector('[data-tw-collection-row-prev]');
      var nextBtn = root.querySelector('[data-tw-collection-row-next]');
      var tabs = root.querySelectorAll('[data-tw-collection-row-tab]');
      var cards = root.querySelectorAll('[data-tw-collection-row-card]');

      function visibleCards() {
        var result = [];
        cards.forEach(function (card) {
          if (!card.hasAttribute('hidden')) result.push(card);
        });
        return result;
      }

      function step() {
        var visible = visibleCards();
        var card = visible[0];
        if (!track || !card) return track ? track.clientWidth : 0;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        if (!track || !prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = max <= 1 || track.scrollLeft >= max - 1;
      }

      function applyFilter(tabId) {
        cards.forEach(function (card) {
          var cardTab = card.getAttribute('data-tw-tab');
          var matches = cardTab === null || cardTab === tabId;
          if (matches) {
            card.removeAttribute('hidden');
          } else {
            card.setAttribute('hidden', '');
          }
        });
        if (track) track.scrollTo({ left: 0 });
        updateButtons();
      }

      if (prevBtn && track) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (nextBtn && track) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      if (track) {
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          applyFilter(tab.getAttribute('data-tab-id'));
        });
      });

      updateButtons();
    }

    document.querySelectorAll('.tw-collection-row').forEach(initCollectionRow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-seo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tw-colseo').forEach(function (blok) {
    var tekst = blok.querySelector('.tw-colseo__tekst');
    var knop = blok.querySelector('.tw-colseo__meer');
    if (!tekst || !knop) return;

    // Alleen inklappen als er echt iets te winnen valt.
    if (tekst.scrollHeight <= 400) return;

    var meer = knop.querySelector('[data-tw-meer]');
    var minder = knop.querySelector('[data-tw-minder]');

    tekst.classList.add('is-dicht');
    knop.hidden = false;

    knop.addEventListener('click', function () {
      var open = tekst.classList.toggle('is-dicht') === false;
      knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (meer) meer.hidden = open;
      if (minder) minder.hidden = !open;
      if (!open) blok.scrollIntoView({ block: 'nearest' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-cost-calc"] && !Shopify.designMode) return;
  try {
    
  // Maanden = prijs / maandbedrag, naar boven afgerond. Puur rekenwerk.
  (() => {
    const start = () => {
      document.querySelectorAll('[data-tw-calc]').forEach((calc) => {
        if (calc.dataset.twCalcInit) return;
        calc.dataset.twCalcInit = '1';
        const slider = calc.querySelector('[data-tw-calc-slider]');
        const prijs = parseInt(calc.dataset.prijsCent, 10) / 100;
        if (!slider || !prijs) return;
        slider.addEventListener('input', () => {
          const per_maand = parseInt(slider.value, 10);
          calc.querySelector('[data-tw-calc-uitgave]').textContent = '€' + per_maand;
          calc.querySelector('[data-tw-calc-maanden]').textContent = Math.ceil(prijs / per_maand);
          calc.querySelector('[data-tw-calc-jaar]').textContent = '€' + per_maand * 12;
          // Gevulde track links van de duim (zie --tw-calc-pct in de stylesheet).
          const pct = ((per_maand - slider.min) / (slider.max - slider.min)) * 100;
          slider.style.setProperty('--tw-calc-pct', pct + '%');
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-intent-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tw-intent-list][data-tw-intent-limit]').forEach(function (list) {
    var button = list.parentElement.querySelector('[data-tw-intent-more]');
    if (!button) return;
    var label = button.querySelector('[data-tw-intent-more-label]');
    var expandedLabel = button.getAttribute('data-expanded-label') || 'Toon minder';
    var collapsedLabel = label ? label.textContent : 'Laad meer';

    button.addEventListener('click', function () {
      var expanded = list.classList.toggle('tw-intent-row__list--expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded ? expandedLabel : collapsedLabel;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-product-compare"] && !Shopify.designMode) return;
  try {
    
  // Kiezen in een kolom wisselt die kolom ter plekke: alle panelen staan al in
  // de HTML, alleen het gekozen paneel is zichtbaar. Geen navigatie, geen fetch.
  (() => {
    // Zet een kolom op een model: het paneel tonen, de kiezer meezetten en de
    // donkere "dit model"-stijl volgen.
    const zetKolom = (sectie, kolom, gekozen) => {
      kolom.querySelectorAll('[data-tw-compare-panel]').forEach((paneel) => {
        paneel.hidden = paneel.dataset.twComparePanel !== gekozen;
      });
      const huidige = sectie?.dataset.twCompareCurrent;
      // De vaste naamkaart van kolom 1 op een productpagina (geen kiezer): tekst
      // en donkere stijl volgen het paneel dat de mobiele tabs tonen.
      const vast = kolom.querySelector('[data-tw-compare-vast]');
      if (vast) {
        const paneel = kolom.querySelector('[data-tw-compare-panel]:not([hidden])');
        if (paneel && paneel.dataset.twCompareTitle) vast.textContent = paneel.dataset.twCompareTitle;
        vast.classList.toggle('tw-compare__select--current', !!huidige && gekozen === huidige);
      }
      const kiezer = kolom.querySelector('[data-tw-compare-select]');
      if (!kiezer) return;
      if (kiezer.value !== gekozen) kiezer.value = gekozen;
      kiezer.classList.toggle('tw-compare__select--current', !!huidige && gekozen === huidige);
    };

    // Het model dat een kolom nu toont. Dit is de bron voor een ruil, want bij
    // een change-event staat de kiezer zelf al op de nieuwe waarde.
    const huidigModel = (kolom) => kolom.querySelector('[data-tw-compare-panel]:not([hidden])')?.dataset.twComparePanel;

    // Wissel een kolom naar een model. Staat dat model al in een andere kolom,
    // dan krijgt die kolom het model dat hier vrijkomt: zo staat nooit twee
    // keer hetzelfde model naast elkaar (feedback merchant 04-09) en blijft
    // herschikken mogelijk. De badges reizen mee met hun paneel. De mobiele
    // tabs volgen kolom 1, ook als die door de ruil verandert.
    const wisselNaar = (sectie, kolom, gekozen) => {
      if (!sectie) {
        zetKolom(sectie, kolom, gekozen);
        return;
      }
      const vorige = huidigModel(kolom);
      if (vorige && vorige !== gekozen) {
        sectie.querySelectorAll('[data-tw-compare-col]').forEach((andere) => {
          if (andere !== kolom && huidigModel(andere) === gekozen) zetKolom(sectie, andere, vorige);
        });
      }
      zetKolom(sectie, kolom, gekozen);
      const eerste = huidigModel(sectie.querySelector('[data-tw-compare-col]'));
      sectie.querySelectorAll('[data-tw-compare-tab]').forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.twCompareTab === eerste);
      });
    };

    const koppel = (kolom) => {
      if (kolom.dataset.twCompareInit) return;
      kolom.dataset.twCompareInit = '1';

      const kiezer = kolom.querySelector('[data-tw-compare-select]');
      if (!kiezer) return;

      kiezer.addEventListener('change', () => {
        wisselNaar(kolom.closest('.tw-compare'), kolom, kiezer.value);
      });
    };

    // De mobiele tabs sturen kolom 1 aan — zelfde wissel als de kiezer daar.
    const koppelTabs = (sectie) => {
      if (sectie.dataset.twCompareTabsInit) return;
      sectie.dataset.twCompareTabsInit = '1';
      sectie.querySelectorAll('[data-tw-compare-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const kolom = sectie.querySelector('[data-tw-compare-col]');
          if (!kolom) return;
          wisselNaar(sectie, kolom, tab.dataset.twCompareTab);
        });
      });
    };

    // De vervaging rechts van de modellenrij verdwijnt zodra je aan het einde
    // van de rij bent; zo blijft zichtbaar dat er méér modellen staan zolang
    // dat zo is.
    const volgScroll = (tabs) => {
      const wrap = tabs.closest('[data-tw-compare-tabswrap]');
      if (!wrap) return;
      const bij = () => {
        const eind = tabs.scrollLeft + tabs.clientWidth >= tabs.scrollWidth - 4;
        if (eind) wrap.setAttribute('data-eind', '');
        else wrap.removeAttribute('data-eind');
      };
      tabs.addEventListener('scroll', bij, { passive: true });
      window.addEventListener('resize', bij);
      bij();
    };

    const start = () => {
      document.querySelectorAll('[data-tw-compare-col]').forEach(koppel);
      document.querySelectorAll('[data-tw-compare-tabs]').forEach((tabs) => {
        const sectie = tabs.closest('.tw-compare');
        if (sectie) koppelTabs(sectie);
        volgScroll(tabs);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    // De theme-editor herlaadt secties zonder paginarefresh.
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductRow(section) {
      var track = section.querySelector('[data-tw-product-row-track]');
      var prevBtn = section.querySelector('[data-tw-product-row-prev]');
      var nextBtn = section.querySelector('[data-tw-product-row-next]');
      if (!track || !prevBtn || !nextBtn) return;

      function step() {
        var card = track.querySelector('.tw-product-row__card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var max = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= max - 1;
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    document.querySelectorAll('.tw-product-row').forEach(initProductRow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-subcat-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSubcatNav(nav) {
      var track = nav.querySelector('[data-tw-subcat-nav-track]');
      var prevBtn = nav.querySelector('[data-tw-subcat-nav-prev]');
      var nextBtn = nav.querySelector('[data-tw-subcat-nav-next]');
      if (!track || !prevBtn || !nextBtn) return;

      function step() {
        var card = track.querySelector('.tw-subcat-nav__card');
        if (!card) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var max = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= max - 1;
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    document.querySelectorAll('.tw-subcat-nav').forEach(initSubcatNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ENDPOINT = 'https://widget.trustpilot.com/trustbox-data/539ad60defb9600b94d7df2c';
    var GEWEIGERD = /k[aä]rcher|kaercher|philips|bissell|vileda|polti/i;
    var HEEFT_LETTER = /[A-Za-zÀ-ɏ]/;
    var MIN_TEKST = 60;
    var MAX_TEKST = 360; /* langere teksten kapt de kaart af op zeven regels (zie CSS) */
    var MIN_KAARTEN = 3; /* buiten nl: minder bruikbare reviews in een taal = volgende taal */
    /* Winkeltaal naar Trustpilot-locale. Een taal die hier niet in staat slaat
       de eigen poging over en gaat direct naar Engels. */
    var LOCALES = { nl: 'nl-NL', en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT', da: 'da-DK', fi: 'fi-FI', sv: 'sv-SE' };

    function maakSter(src, extraClass) {
      var img = document.createElement('img');
      img.className = 'tw-testimonials-stars__star' + extraClass;
      img.src = src;
      img.alt = '';
      img.width = 20;
      img.height = 20;
      return img;
    }

    function maakHalveSter(urls) {
      var span = document.createElement('span');
      span.className = 'tw-testimonials-stars__star tw-testimonials-stars__star--half';
      var bg = document.createElement('img');
      bg.src = urls.halfbg;
      bg.alt = '';
      bg.width = 20;
      bg.height = 20;
      var fg = document.createElement('img');
      fg.className = 'tw-testimonials-stars__star-fg';
      fg.src = urls.half;
      fg.alt = '';
      fg.width = 14;
      fg.height = 13;
      span.appendChild(bg);
      span.appendChild(fg);
      return span;
    }

    function zetSterren(wrapper, score, urls) {
      if (!wrapper || !score) return;
      var vorige = parseFloat(((wrapper.dataset.twScore || wrapper.getAttribute('aria-label') || '') + '').replace(',', '.'));
      if (vorige === score) return;
      wrapper.dataset.twScore = String(score);
      var sterLabel = (document.querySelector('meta[name="tw-stars-label"]') || {}).content || '__RATING__ van 5 sterren';
      wrapper.setAttribute('aria-label', sterLabel.replace('__RATING__', String(score).replace('.', ',')));
      wrapper.textContent = '';
      var vol = Math.floor(score);
      var half = score - vol >= 0.25;
      for (var i = 1; i <= 5; i++) {
        if (i <= vol) {
          wrapper.appendChild(maakSter(urls.vol, ''));
        } else if (half && i === vol + 1) {
          wrapper.appendChild(maakHalveSter(urls));
        } else {
          wrapper.appendChild(maakSter(urls.leeg, ' tw-testimonials-stars__star--empty'));
        }
      }
    }

    /* Zelfde grenzen als snippets/tw-testimonials-datum.liquid. */
    function relatief(iso) {
      /* Kalenderdagen, geen 24-uursblokken: een review van gisteravond heet
         vanochtend al "gisteren". */
      var d = new Date(iso + 'T00:00:00');
      if (isNaN(d.getTime())) return '';
      var nu = new Date();
      nu.setHours(0, 0, 0, 0);
      var dagen = Math.round((nu.getTime() - d.getTime()) / 86400000);
      if (dagen <= 0) return 'vandaag';
      if (dagen === 1) return '1 dag geleden';
      if (dagen < 7) return dagen + ' dagen geleden';
      if (dagen < 30) { var w = Math.floor(dagen / 7); return w === 1 ? '1 week geleden' : w + ' weken geleden'; }
      if (dagen < 365) { var m = Math.floor(dagen / 30); return m === 1 ? '1 maand geleden' : m + ' maanden geleden'; }
      return Math.floor(dagen / 365) + ' jaar geleden';
    }

    /* Buiten nl dezelfde grenzen als relatief(), maar de tekst komt uit de
       browser in de taal van de pagina ("hace 3 días", "2 weeks ago"), zodat er
       geen Nederlandse datum onder een Engelse review op de Spaanse winkel
       staat. Kent de browser dat niet, dan de Nederlandse tekst. */
    function relatiefInTaal(iso, taal) {
      if (taal === 'nl' || !window.Intl || !Intl.RelativeTimeFormat) return relatief(iso);
      var d = new Date(iso + 'T00:00:00');
      if (isNaN(d.getTime())) return '';
      var nu = new Date();
      nu.setHours(0, 0, 0, 0);
      var dagen = Math.round((nu.getTime() - d.getTime()) / 86400000);
      try {
        if (dagen <= 0) return new Intl.RelativeTimeFormat(taal, { numeric: 'auto' }).format(0, 'day');
        var rtf = new Intl.RelativeTimeFormat(taal, { numeric: 'always' });
        if (dagen < 7) return rtf.format(-dagen, 'day');
        if (dagen < 30) return rtf.format(-Math.floor(dagen / 7), 'week');
        if (dagen < 365) return rtf.format(-Math.floor(dagen / 30), 'month');
        return rtf.format(-Math.floor(dagen / 365), 'year');
      } catch (e) {
        return relatief(iso);
      }
    }

    function zetDatum(kaart, iso, taal) {
      var tekst = relatiefInTaal(iso, taal);
      if (!tekst) return;
      var el = kaart.querySelector('.tw-testimonials__date');
      if (!el) {
        var meta = kaart.querySelector('.tw-testimonials__meta') || kaart.querySelector('.tw-testimonials__content');
        if (!meta) return;
        el = document.createElement('time');
        el.className = 'tw-testimonials__date';
        meta.appendChild(el);
      }
      el.setAttribute('datetime', iso);
      el.textContent = tekst;
    }

    function zetRegels(el, tekst) {
      if (!el) return;
      el.textContent = '';
      var regels = tekst.replace(/\r/g, '').split('\n');
      for (var i = 0; i < regels.length; i++) {
        if (i) el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode(regels[i]));
      }
    }

    /* Reviews uit een antwoord van het endpoint: alleen de gevraagde taal en
       de criteria van scripts/sync-trustpilot-reviews.mjs, nieuwste eerst. */
    function verzamel(data, lang) {
      return (data.reviews || []).map(function (r) {
        return {
          titel: ((r.title || '') + '').trim(),
          tekst: ((r.text || '') + '').trim(),
          auteur: (((r.consumer && r.consumer.displayName) || '') + '').trim(),
          sterren: r.stars,
          datum: ((r.createdAt || '') + '').slice(0, 10),
          taal: r.language,
          link: ((r.reviewUrl || '') + '').trim()
        };
      }).filter(function (r) {
        if (r.sterren < 4 || r.taal !== lang) return false;
        if (!r.titel || !r.auteur || !r.datum) return false;
        if (!HEEFT_LETTER.test(r.titel)) return false; /* titels van alleen sterren of emoji */
        if (r.tekst.length < MIN_TEKST || r.tekst.length > MAX_TEKST) return false;
        if (GEWEIGERD.test(r.titel) || GEWEIGERD.test(r.tekst)) return false;
        return true;
      }).sort(function (a, b) {
        return a.datum < b.datum ? 1 : a.datum > b.datum ? -1 : 0;
      });
    }

    function ververs(sectie) {
      if (!sectie || !window.fetch) return;
      var carousel = sectie.querySelector('.tw-testimonials__track');
      if (!carousel) return;
      var bedrijf = sectie.dataset.twBusiness || '617ff6896bc505ee409c533a';
      var aantal = parseInt(sectie.dataset.twCount, 10) || 4;
      var urls = { vol: sectie.dataset.twStarFull, leeg: sectie.dataset.twStarEmpty, halfbg: sectie.dataset.twStarHalfbg, half: sectie.dataset.twStarHalf };
      var taal = ((sectie.dataset.twLang || 'nl') + '').toLowerCase();
      /* Buiten nl staan er lege kaarten en start de sectie verborgen (zie de
         toelichting in de sectie): eerst de taal van de bezoeker, dan Engels,
         en bij minder dan MIN_KAARTEN bruikbare reviews blijft hij verborgen. */
      var alleenLive = sectie.hasAttribute('data-tw-live-only');
      var pogingen = [];
      if (LOCALES[taal]) pogingen.push([LOCALES[taal], taal]);
      if (alleenLive && taal !== 'en') pogingen.push([LOCALES.en, 'en']);

      /* Eén fetch per pagina en per taal: assets/tw-trustpilot-live.js cachet
         hem; zonder dat script (mocht het niet geladen zijn) halen we zelf op. */
      function haal(locale, lang) {
        if (window.twTrustpilot && window.twTrustpilot.load) return window.twTrustpilot.load(bedrijf, locale, lang);
        var url = ENDPOINT + '?businessUnitId=' + encodeURIComponent(bedrijf)
          + '&locale=' + encodeURIComponent(locale) + '&reviewsPerPage=50&reviewLanguages=' + encodeURIComponent(lang) + '&reviewStars=4,5';
        return fetch(url).then(function (res) {
          if (!res.ok) throw new Error('status ' + res.status);
          return res.json();
        });
      }

      function probeer(i) {
        if (i >= pogingen.length) return Promise.reject(new Error('geen taal'));
        var lang = pogingen[i][1];
        return haal(pogingen[i][0], lang).then(function (data) {
          var reviews = verzamel(data, lang);
          if (alleenLive && reviews.length < MIN_KAARTEN && i + 1 < pogingen.length) return probeer(i + 1);
          return { data: data, reviews: reviews, lang: lang };
        });
      }

      probeer(0).then(function (uitkomst) {
        if (!sectie.isConnected) return; /* de editor heeft de sectie intussen vervangen */
        var data = uitkomst.data;
        var reviews = uitkomst.reviews;
        if (alleenLive && reviews.length < MIN_KAARTEN) {
          sectie.dataset.twLiveTaal = 'geen'; /* meetmarker: verborgen gebleven */
          return;
        }

        var kaarten = carousel.querySelectorAll('.tw-testimonials__card');
        var n = Math.min(aantal, kaarten.length, reviews.length);
        for (var i = 0; i < n; i++) {
          var kaart = kaarten[i];
          var r = reviews[i];
          zetSterren(kaart.querySelector('.tw-testimonials-stars'), r.sterren, urls);
          zetRegels(kaart.querySelector('.tw-testimonials__quote'), r.titel);
          zetRegels(kaart.querySelector('.tw-testimonials__description'), r.tekst);
          var naam = kaart.querySelector('.tw-testimonials__name');
          if (naam) naam.textContent = r.auteur;
          zetDatum(kaart, r.datum, taal);
          /* Klik op de kaart opent precies deze review op Trustpilot. */
          if (kaart.tagName === 'A' && /^https:\/\/[a-z.]*trustpilot\.com\//.test(r.link)) {
            kaart.href = r.link;
            if (taal === 'nl') kaart.title = 'Lees deze review op Trustpilot';
          }
        }
        if (alleenLive) {
          /* Kaarten zonder review weg, dan pas in beeld. */
          for (var j = kaarten.length - 1; j >= n; j--) kaarten[j].parentNode.removeChild(kaarten[j]);
          sectie.removeAttribute('hidden');
        }

        var bu = data.businessUnit || {};
        if (bu.trustScore) {
          zetSterren(sectie.querySelector('.tw-testimonials__rating-stars'), bu.trustScore, urls);
        }
        var totaal = bu.numberOfReviews && bu.numberOfReviews.total;
        var strong = sectie.querySelector('.tw-testimonials__rating-count-strong');
        if (strong && totaal) {
          strong.textContent = totaal >= 100
            ? (Math.floor(totaal / 100) * 100).toLocaleString(document.documentElement.lang || 'nl-NL') + '+'
            : String(totaal);
        }
        if (n > 0) {
          sectie.dataset.twLive = reviews[0].datum; /* meetmarker: datum van de nieuwste getoonde review */
          sectie.dataset.twLiveTaal = uitkomst.lang; /* meetmarker: taal van de getoonde reviews */
        }
      }).catch(function () {
        /* beginstand blijft staan; buiten nl blijft de sectie verborgen */
      });
    }

    function init(root) {
      var secties = (root && root.querySelectorAll ? root : document).querySelectorAll('.tw-testimonials[data-tw-dynamic]');
      for (var i = 0; i < secties.length; i++) ververs(secties[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    /* Theme-editor: na een herlaad van de sectie opnieuw verversen. */
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-versus"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = () => {
      document.querySelectorAll('.tw-versus').forEach((sectie) => {
        if (sectie.dataset.twVersusInit) return;
        sectie.dataset.twVersusInit = '1';

        // Mobiele tabs: wisselen welk alternatief naast de Techweise-kolom staat.
        sectie.querySelectorAll('[data-tw-versus-tab]').forEach((tab) => {
          tab.addEventListener('click', () => {
            const doel = tab.dataset.twVersusTab;
            sectie.querySelectorAll('[data-tw-versus-col]').forEach((kolom) => {
              kolom.classList.toggle('is-active', kolom.dataset.twVersusCol === doel);
            });
            sectie.querySelectorAll('[data-tw-versus-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
          });
        });

      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-video-reels"] && !Shopify.designMode) return;
  try {
    
  // Klik speelt af en pauzeert; er loopt er nooit meer dan één tegelijk.
  (() => {
    const start = () => {
      document.querySelectorAll('[data-tw-reels]').forEach((track) => {
        if (track.dataset.twReelsInit) return;
        track.dataset.twReelsInit = '1';

        track.querySelectorAll('.tw-reels__tile').forEach((tile) => {
          const video = tile.querySelector('video');
          const knop = tile.querySelector('[data-tw-reels-play]');
          if (!video || !knop) return;

          const wissel = () => {
            if (video.paused) {
              track.querySelectorAll('video').forEach((v) => { if (v !== video) v.pause(); });
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          };

          knop.addEventListener('click', wissel);
          video.addEventListener('click', wissel);
          video.addEventListener('play', () => tile.classList.add('is-playing'));
          video.addEventListener('pause', () => tile.classList.remove('is-playing'));
        });
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-multi-column"] && !Shopify.designMode) return;
  try {
    
  // Techweise — de tegels tonen een play-knop en starten pas als
  // de bezoeker erop klikt. Zonder deze vlag houdt de sectie het autoplay-gedrag
  // van de eerdere ontwikkelaar (`js-autoplay-video`), dus andere pagina's
  // merken hier niets van.
  //
  // Klikken op een tegel start of pauzeert de video; de knop verdwijnt zolang
  // hij speelt. Er speelt er nooit meer dan één tegelijk.
  (() => {
    const koppel = (knop) => {
      if (knop.dataset.twPlayInit) return;
      knop.dataset.twPlayInit = '1';

      const kader = knop.closest('.multicolumn-media__media');
      const video = kader && kader.querySelector('video');
      if (!video) { knop.hidden = true; return; }

      const toon = () => { knop.hidden = !video.paused; };

      const wissel = () => {
        if (video.paused) {
          // Andere tegels stoppen, zodat er niet twee door elkaar spelen.
          document.querySelectorAll('.tw-videorow video').forEach((v) => {
            if (v !== video && !v.paused) v.pause();
          });
          video.play().catch(() => {
            // Sommige browsers weigeren een video met geluid, ook na een klik.
            // Dan alsnog starten zonder geluid in plaats van niets doen.
            video.muted = true;
            video.play().catch(() => { /* blijft weigeren; de knop blijft staan */ });
          });
        } else {
          video.pause();
        }
      };

      knop.addEventListener('click', wissel);
      kader.addEventListener('click', (e) => { if (e.target !== knop && !knop.contains(e.target)) wissel(); });
      video.addEventListener('play', toon);
      video.addEventListener('pause', toon);
      video.addEventListener('ended', toon);
      toon();
    };

    const start = () => document.querySelectorAll('.tw-videorow [data-tw-play]').forEach(koppel);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    // De theme-editor herlaadt secties zonder paginarefresh.
    document.addEventListener('shopify:section:load', start);
  })();

  // De fades verdwijnen aan het uiteinde waar je staat, anders blijft de eerste
  // of laatste tegel achter wit schemeren. Een beginscrollpositie zetten voor de
  // oude peek-look heeft geen zin: scroll-snap trekt hem meteen terug naar het
  // snappunt van de eerste tegel.
  (() => {
    const koppel = (grid) => {
      if (grid.dataset.twScrollInit) return;
      grid.dataset.twScrollInit = '1';

      const inner = grid.closest('.multicolumn-media__inner');
      const bijwerken = () => {
        inner.classList.toggle('tw-videorow--at-start', grid.scrollLeft <= 4);
        inner.classList.toggle('tw-videorow--at-end', grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4);
      };
      grid.addEventListener('scroll', bijwerken, { passive: true });
      window.addEventListener('resize', bijwerken);
      bijwerken();
    };

    const start = () => document.querySelectorAll('.tw-videorow .multicolumn-media__grid').forEach(koppel);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
